export enum EntitySize {
  // micro
  // <50m revenue
  Micro = 'Micro',

  // small and medium-sized companies
  // 50m - 200m revenue
  SME = 'SME',

  // middle-market / mid market companies
  // 200m - 1bn revenue
  MidMarket = 'MidMarket',

  // industrial
  // >1bn revenue
  Industrial = 'Industrial',

  // Unknown
  Unknown = 'Unknown',
}

export const EntitySizeDescriptor = Object.freeze({
  [EntitySize.Micro]: 'Micro',
  [EntitySize.SME]: 'SME',
  [EntitySize.MidMarket]: 'Mid Market',
  [EntitySize.Industrial]: 'Industrial',
  [EntitySize.Unknown]: 'Unknown',
});

export const ESAdditionalInformationDescriptor = Object.freeze({
  [EntitySize.Micro]: '< $50M Revenue',
  [EntitySize.SME]: '$50M - $200M',
  [EntitySize.MidMarket]: '$200M - $1B',
  [EntitySize.Industrial]: '> $ 1B',
});
